import { computed, inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import * as TagsActions from './tags.actions';
import { CreateTagData, TagsQueryParams, UpdateTagData } from './tags.actions';
import * as TagsSelectors from './tags.selectors';

@Injectable({
  providedIn: 'root',
})
export class TagsFacade {
  private store = inject(Store);

  tags$ = this.store.select(TagsSelectors.selectAllTags);
  loading$ = this.store.select(TagsSelectors.selectTagsLoading);
  error$ = this.store.select(TagsSelectors.selectTagsError);
  pagination$ = this.store.select(TagsSelectors.selectTagsPagination);

  tags = toSignal(this.tags$, { initialValue: [] });
  loading = toSignal(this.loading$, { initialValue: false });

  filteredTags = computed(() => {
    return this.tags();
  });

  loadTags(params?: TagsQueryParams): void {
    this.store.dispatch(TagsActions.loadTags({ params }));
  }

  createTag(tagData: CreateTagData): void {
    this.store.dispatch(TagsActions.createTag({ tagData }));
  }

  updateTag(id: string, tagData: UpdateTagData): void {
    this.store.dispatch(TagsActions.updateTag({ id, tagData }));
  }

  deleteTag(id: string): void {
    this.store.dispatch(TagsActions.deleteTag({ id }));
  }
}
